import { getRequest, postRequest } from '../services/http';

export const addEditScheduleDay = async (data) => {
  const response = await postRequest({
    url: `user/branch-stores/${data.id}/schedules/`,
    token: data.token,
    data: data.params,
  });

  return response;
};

export const getSchedules = async (data) => {
  const response = await getRequest({
    url: `branch-stores/${data.id}/schedules/`,
    token: data.token,
  });

  return response;
};
